import { useState } from 'react';
import { CONTEXT_MODAL_AUTO_WIDTH } from '../context-modal';

const MESSAGE_CONTEXT_MODAL_PROPS = {
  contextTheme: 'instructionHub',
  modalWidth: CONTEXT_MODAL_AUTO_WIDTH
};

export default function useInstructionHubMenuGuard(isBlocked) {
  const [isInstructionHubMessageShown, setMessageShown] = useState(false);

  function runUnlessInstructionHubBlocked(action) {
    if (isBlocked) {
      setMessageShown(true);
      return;
    }
    action();
  }

  return {
    isInstructionHubMessageShown,
    hideInstructionHubMessage: () => setMessageShown(false),
    runUnlessInstructionHubBlocked,
    instructionHubContextModalProps: isInstructionHubMessageShown
      ? MESSAGE_CONTEXT_MODAL_PROPS
      : {}
  };
}



// WEBPACK FOOTER //
// ./components/instruction-hub-message/use-instruction-hub-menu-guard.js